<p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [loading]="loading"
    [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

    <ng-template pTemplate="header">
        <tr>
            <th *ngFor="let col of displayedColumns">
                {{ col.header }}
            </th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-i="rowIndex">
        <tr>
            <td *ngFor="let col of displayedColumns">
                <ng-container [ngSwitch]="col.type">

                    <!-- Name -->
                    <ng-container *ngSwitchCase="'contact_name'">
                        {{ rowData['name'] || 'N/A' }}
                    </ng-container>

                    <!-- Mobile -->
                    <ng-container *ngSwitchCase="'phone'">
                        {{ rowData['mobile_number'] || 'N/A' }}
                    </ng-container>

                    <!-- Email -->
                    <ng-container *ngSwitchCase="'email'">
                        {{ rowData['email'] || 'N/A' }}
                    </ng-container>

                    <!-- Call Status -->
                    <ng-container *ngSwitchCase="'call_status'">
                        {{ rowData['call_status'] ? (rowData['call_status'] | titlecase) : 'N/A' }}
                    </ng-container>

                    <!-- Status -->
                    <ng-container *ngSwitchCase="'status'">
                        {{ rowData['status'] ? (rowData['status'] | titlecase) : 'N/A' }}
                    </ng-container>


                    <!-- Created At -->
                    <ng-container *ngSwitchCase="'created_at'">
                        {{ rowData['created_at'] | date:'mediumDate' }}
                    </ng-container>

                    <!-- Actions -->
                    <ng-container *ngSwitchCase="'actions'">
                        <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text"
                            (click)="deleteContactPopUp(rowData)" pTooltip="Delete Contact">
                        </button>
                    </ng-container>

                    <!-- Default -->
                    <ng-container *ngSwitchDefault>
                        {{ rowData[col.field] || 'N/A' }}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="loading">
        <tr>
            <td colspan="6" class="text-center">
                <p-progressSpinner></p-progressSpinner>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="displayedColumns.length + 1" class="no-data-record-found">
                <p>No records found</p>
            </td>
        </tr>
    </ng-template>
</p-table>



<p-dialog [modal]="true" [(visible)]="isDeleteContact" [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">

    <div class="flex items-center justify-center dialog-header ">
        Delete Contact

        <div class="absolute right-2">
            <button (click)="isDeleteContact = false" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>

    </div>

    <div class="dialog-content">
        <div class="mt-2 mb-2" style="font-weight: 500; font-size: 17px; text-align: center;">
            <h2 class="text-lg font-semibold text-gray-800 mb-2">Are you sure you want to delete this contact?</h2>

            <p class="text-gray-600 mb-4">
                <span class="font-medium">Name:</span> {{selectedContact?.name}} <br />
                <span class="font-medium">Mobile:</span> {{selectedContact?.mobile_number}}
            </p>
        </div>

        <div class="flex gap-4 mt-7 justify-end">

            <p-button label="Cancel" severity="danger" variant="outlined" (click)="isDeleteContact = false"></p-button>
            <p-button label="Delete" severity="danger" icon="pi pi-trash" (click)="deleteContact()"
                [disabled]="btnLoading" [loading]="btnLoading">
            </p-button>


        </div>

    </div>

</p-dialog>